import {IPermissionsStoreState} from './IPermissionsStoreState';

export const permissionsReducer = {
  setLoading: (state: IPermissionsStoreState, action: {payload: boolean}) => {
    state.loading = action.payload;
  },
};
